
export const URLS = {
  rails_service_blob: '/rails/active_storage/blobs/redirect/:signed_id/:filename',
  printer_server: 'https://web2print.ferien-karlsruhe.de:4443/'
}
export const RAILS_ENV = 'staging';
